import { createFormContext } from '@mantine/form';
import { CreatePrescriptionParameters, DeactivatePrescriptionsParameters } from 'models/prescription';
import { RuleDataForm } from 'models/rules';

export const [DeactivePrescriptionsFormProvider, useDeactivePrescriptionsFormContext, useDeactivatePrescriptionsForm] =
  createFormContext<DeactivatePrescriptionsParameters>();

export const [CreatePrescriptionFormProvider, useCreatePrescriptionFormContext, useCreatePrescriptionForm] =
  createFormContext<CreatePrescriptionParameters>();

export const [CreateRuleFormProvider, useCreateRuleFormContext, useCreateRuleForm] = createFormContext<RuleDataForm>();
